import React from 'react';
import useChatStore from '../store/useChatStore';

const OrderDetailsPage = ({ order }) => {
  const { setCurrentScreen } = useChatStore();

  const handleGetHelp = () => {
    // Handle "Get help" action here
    alert('Redirecting to help...');
  };

  return (
    <div className="order-details-page">
      {/* Order Card */}
      <div className="order-card" style={{ width: 'auto' }}>
        <div className="order-card-header">
          <span>Order ID: {order.id}</span>
          <span>{order.status}</span>
        </div>
        <div className="order-card-body">
          <p>{order.date}</p>
          <p>
            <strong>Ship to:</strong> {order.address}
          </p>
        </div>
        <p onClick={handleGetHelp} className="get-help-link">
          Get help &gt;
        </p>
      </div>
    </div>
  );
};

export default OrderDetailsPage;
